module.exports = __webpack_public_path__ + "img/google-data-studio.52d85371.jpg";